/**
 * Giving the focus back to what had it when a dialog closes - except to an editing host. A rich-text editor whose toolbar keeps the focus in it (the
 * link button asks for a URL) still has it when the dialog opens; the selection then moves into the dialog's field, and `focus()` on the host after
 * that puts the caret at the START of the editor and scrolls it into view (measured in Chromium and WebKit): the writer is thrown to the top of the
 * article and what is typed next lands there. The code that opened the dialog from an editor restores its own range. And no scroll for the rest:
 * what had the focus is where the person was, the page does not move to it.
 */
const EDITING_HOST = '[contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]'

/** Whether the element is an editing host, or inside one: the places a caret lives that a `focus()` would move. */
export function isEditingHost(el: Element): boolean {
  return (el as HTMLElement).isContentEditable === true || el.closest(EDITING_HOST) !== null
}

/** Gives the focus back to `previous` (what had it before the dialog), unless it is gone from the page or is an editing host. */
export function giveFocusBack(previous: HTMLElement | null): void {
  if (!previous || !previous.isConnected || isEditingHost(previous)) return
  previous.focus?.({ preventScroll: true })
}
